import { Play } from "lucide-react";

/**
 * "VIDEO AVAILABLE" badge — drop into auction/collection cards when product has a video.
 * Designed to sit absolutely positioned (top-left or top-right) over a product image.
 */
const VideoBadge = ({ className = "", label = "Video Available" }) => (
  <span
    data-testid="video-available-badge"
    className={`inline-flex items-center gap-1.5 bg-black/80 text-gold border border-gold/50 font-accent text-[9px] tracking-[0.22em] uppercase px-2.5 py-1.5 backdrop-blur-sm ${className}`}
  >
    <Play size={9} fill="currentColor" /> {label}
  </span>
);

export default VideoBadge;
